import { defineComponent as _defineComponent } from 'vue'
import { computed, unref } from 'vue';
    import { TravTab } from './TravTab';

    export interface IProps {
        tabs: TravTab<string>[],
        value: string;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'TravTabs',
  props: {
    tabs: null,
    value: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({(event: 'input', value: string): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
        tabs: TravTab<string>[],
        value: string;
    }

    

    

    const selectedTabType = computed({
        get: () => props.value,
        set: (type) => {
            emit('input', type);
        },
    });


return { __sfc: true,emit, props, selectedTabType }
}

})